interface AssistantGridProps {
  children: React.ReactNode;
}

export default function AssistantGrid({ children }: AssistantGridProps) {
  return <div className="l-assistant-grid">{children}</div>;
}
